// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_7f58ece9"};